export const auth = {
  authHomeTitle: 'Empecemos',
  authHomeButtonBranded: 'Continuar con E-mail',
  authHomeButtonApple: 'Continuar con Apple',
  authHomeButtonGoogle: 'Continuar con Google',
  authHomeButtonFacebook: 'Continuar con Facebook',
  authHomeButtonLinkedin: 'Continuar con LinkedIn',
  authStartTitle: 'Iniciar sesión o Registrarse',
  authStartInputTitle: 'E-mail',
  authStartInputTitleError: '¡Introduce una dirección de correo electrónico válida!',
  authStartInputPasswordError: '¡Introduce una contraseña válida!',
  authWhoops: '¡Vaya!',
  authStartConfirmButton: 'Continuar',
  authRegisteredTitle: '¡Bienvenido de nuevo!',
  authStartPlaceholderTitle: 'E-mail',
  authRegisteredInputTitle: 'Contraseña',
  authRegisteredForgotPassword: '¿Olvidaste tu contraseña?',
  authAlertIncorrectPassword: 'Tu E-mail o Contraseña es incorrecta',
  authAlertRequiredPassword: 'Introduce una contraseña válida',
  authFinishSignUpTitle: 'Finalizar Registro',
  authFinishSignUpEmailInputTitle: 'E-mail',
  authFinishSignUpFirstNameInputTitle: 'Nombre',
  authFinishSignUpLastNameInputTitle: 'Apellido',
  authFinishSignUpPasswordInputTitle: 'Contraseña',
  authFinishSignUpTipContent:
    '<ul class="text-14 pl-4 text-black"><li class="-ml-4 list-none">Te recomendamos usar:</li><li class="list-disc">Al menos 8 caracteres</li><li class="list-disc">Incluir 1 número</li><li class="list-disc">Incluir 1 símbolo especial</li></ul>',
  authFinishSignUpPrivacyAndTerms: {
    text1: 'Al hacer clic en Registrarse, aceptas nuestra',
    privacyPolicy: 'Política de privacidad',
    text2: 'y',
    termsOfUse: 'Condiciones de uso'
  },
  authFinishSignUpConfirmButton: 'Registrarse',
  authFinishSignUpErrorFirstName: '¡El Nombre no puede estar vacío!',
  authFinishSignUpErrorLastName: '¡El Apellido no puede estar vacío!',
  authFinishSignUpErrorPassword: '¡La Contraseña es demasiado corta!',
  authEmailConfirmationTitle: 'Revisa tu bandeja de entrada',
  authEmailConfirmationContent:
    'Hemos enviado un correo electrónico de confirmación para verificar tu dirección de correo electrónico. Por favor, asegúrate de revisar también tu carpeta de spam si no lo encuentras en tu bandeja de entrada.',
  authEmailConfirmationConfirmButton: 'Volver a Iniciar sesión',
  authAlertEmailConfirmation: '¡Por favor, revisa tu bandeja de entrada para confirmar tu correo electrónico!',
  authResetPasswordTitle: 'Revisa tu bandeja de entrada',
  authResetPasswordDescription:
    'Hemos enviado un enlace para restablecer tu contraseña a tu correo electrónico. Por favor, asegúrate de revisar también tu carpeta de spam si no lo encuentras en tu bandeja de entrada.',
  authResetPasswordButton: 'Volver a iniciar sesión',
  authNewPasswordTitle: 'Introduce una nueva contraseña',
  authNewPasswordInputTitle: 'Nueva contraseña',
  authNewPasswordButton: 'Restablecer contraseña',
  authNewPasswordAlertValidation: 'Tu contraseña no es lo suficientemente segura',
  authPasswordChangeSuccessTitle: '¡Contraseña cambiada!',
  authPasswordChangeSuccessContent: '¡Tu contraseña se ha cambiado con éxito!',
  authPasswordChangeSuccessButton: 'Volver a iniciar sesión',
  authPasswordChangeErrorTitle: '¡Error!',
  authPasswordChangeErrorContent: '¡Algo salió mal al intentar restablecer tu contraseña! Inténtalo de nuevo más tarde.',
  authPasswordChangeErrorButton: 'Volver a iniciar sesión',
  authInvitationTitle: 'Elige una contraseña',
  authInvitationInputTitle: 'Contraseña',
  authInvitationButton: 'Configurar contraseña',
  authEmailAddressConfirmed: '¡Dirección de correo electrónico confirmada!'
}
